module.exports = __webpack_public_path__ + "static/img/p1wifi.35f3f097.png";